<header class="stallion-header">
  <div
    class="container is-flex is-flex-direction-row is-flex-wrap-nowrap is-justify-content-space-between is-align-items-center"
  >
    <img
      *ngIf="restrictedNavigation"
      class="header-img"
      ngSrc="assets/img/stallion-logo-black.svg"
      alt="Stallion Logo"
      data-qa-id="non-clickable-logo"
      width="141"
      height="26"
    />
    <a *ngIf="!restrictedNavigation" class="is-flex" href="https://www.stallion.com/" data-qa-id="clickable-logo">
      <img
        class="header-img"
        ngSrc="assets/img/stallion-logo-black.svg"
        width="230"
        height="40"
        alt="Stallion Logo"
        priority
      />
    </a>
  </div>
</header>
<div class="main-content">
  <ng-content></ng-content>
</div>
<footer class="stallion-footer">
  <div class="container">
    <div class="columns is-align-items-center">
      <div class="column logo-column">
        <img
          class="footer-img"
          ngSrc="assets/img/stallion-logo-white.svg"
          alt="Stallion Logo"
          data-qa-id="stallion-footer-img"
          height="50"
          width="270"
          priority
        />
      </div>
      <div class="column has-text-right-tablet">
        <div>
          Made with <img ngSrc="assets/img/ah_heart.svg" alt="Heart Icon" width="17" height="16" /> by the people at
          Analyte Health
        </div>
      </div>
    </div>
  </div>
</footer>
